// ===============================================
// TRANSLATIONS - الترجمات
// ===============================================
export const translations = {
  ar: {
    selectMonth: 'اختر الشهر',
    selectYear: 'اختر السنة',
    allMonths: 'كل الشهور',
    january: 'يناير',
    february: 'فبراير',
    march: 'مارس',
    april: 'أبريل',
    may: 'مايو',
    june: 'يونيو',
    july: 'يوليو',
    august: 'أغسطس',
    september: 'سبتمبر',
    october: 'أكتوبر',
    november: 'نوفمبر',
    december: 'ديسمبر',
    // Page Header
    pageTitle: 'الراتب والمزايا',
    pageSubtitle: 'تفصيل شامل للراتب مع حسابات النظام الضريبي المصري',
    // Loading States
    loadingSalary: 'جاري تحميل معلومات الراتب...',
    creatingPayroll: 'جاري إنشاء كشف الراتب...',
    // Error Messages
    errorTitle: 'خطأ',
    missingDataTitle: 'لم يتم إعداد بيانات راتبك بعد',
    missingDataError: 'لا يوجد راتب صافي أو إجمالي أو تأميني مسجل على حسابك، لذلك لا يمكن حساب كشف راتبك.',
    missingDataHint: 'تواصل مع مديرك المباشر أو قسم الموارد البشرية لإضافة بيانات راتبك.',
    missingNet: 'الراتب الصافي',
    missingGross: 'الراتب الإجمالي',
    missingInsurance: 'الراتب التأميني',
    notSet: 'غير محدد',
    refresh: 'تحديث',
    noSalaryData: 'لا توجد بيانات راتب متاحة حالياً',
    // Statistics Cards
    grossSalary: 'الراتب الإجمالي',
    totalEarnings: 'إجمالي الدخل قبل الخصومات',
    incomeTax: 'ضريبة الدخل',
    monthlyTaxDeduction: 'خصم الضريبة الشهري',
    socialInsurance: 'التأمين الاجتماعي',
    employeeContribution: 'مساهمة الموظف',
    netSalary: 'صافي الراتب',
    takeHomePay: 'الراتب الصافي المستلم',
    // Deductions Breakdown
    deductionsBreakdown: 'تفصيل الخصومات',
    incomeTaxDesc: 'ضريبة الدخل التصاعدية وفقاً للشرائح الضريبية المصرية',
    socialInsuranceEmployee: 'التأمين الاجتماعي (الموظف)',
    socialInsuranceDesc: 'تغطية المعاش والعجز والوفاة والبطالة',
    martyrsFund: 'صندوق الشهداء',
    martyrsFundDesc: 'مساهمة إلزامية لدعم أسر الشهداء',
    socialInsuranceEmployer: 'التأمين الاجتماعي (صاحب العمل)',
    employerContributionDesc: 'مساهمة صاحب العمل (لا تُخصم من الراتب)',
    penalties: 'الغرامات',
    sickLeave: 'الإجازة المرضية',
    absentDays: 'أيام الغياب',
    // Salary Composition
    salaryComposition: 'تركيبة الراتب',
    basicSalary: 'الراتب الأساسي',
    allowances: 'البدلات',
    ofGrossSalary: 'من الراتب الإجمالي',
    // Salary Summary
    salarySummary: 'ملخص الراتب',
    monthlyGrossSalary: 'الراتب الإجمالي الشهري (جنيه)',
    totalDeductions: 'إجمالي الخصومات (جنيه)',
    netTakeHomePay: 'صافي الراتب المستلم (جنيه)',
    egp: 'جنيه',


    allowancesBreakdown: 'تفصيل البدلات',
    transportationAllowance: 'بدل المواصلات',
    transportationAllowanceDesc: 'بدل المواصلات الشهري',
    variableSalaryAllowance: 'الراتب المتغير',
    variableSalaryDesc: 'المكون المتغير من الراتب',
    overtimeAllowance: 'بدل الساعات الإضافية',
    overtimeAllowanceDesc: 'مكافأة العمل الإضافي',
    bonusAllowance: 'المكافآت',
    bonusAllowanceDesc: 'المكافآت والحوافز',
    expensesAllowance: 'المصروفات',
    expensesAllowanceDesc: 'المصروفات المستردة',
    achievementAllowance: 'بدل الإنجاز',
    achievementAllowanceDesc: 'مكافأة الإنجاز',

    printPayslip: 'طباعة كشف الراتب',
    payslipFor: 'كشف راتب عن',
    employeeInfo: 'بيانات الموظف',
    employeeCode: 'كود الموظف',
    payrollPeriod: 'فترة الراتب',
    to: 'إلى',

    allowanceInstances: 'تفاصيل البدلات',
    deductionInstances: 'تفاصيل الخصومات',
    type: 'النوع',
    description: 'الوصف',
    amount: 'القيمة',
    days: 'أيام',
    hours: 'ساعات',
    total: 'الإجمالي',
    noAllowances: 'لا توجد بدلات',
    noDeductionsRow: 'لا توجد خصومات',

    // Labels for the raw `type` the backend stores on each allowance /
    // deduction row. Anything not listed here (admin-created custom types)
    // falls back to the stored text as-is.
    instanceTypes: {
      absence: 'غياب',
      late: 'تأخير',
      late_arrival: 'تأخير',
      undertime: 'نقص ساعات',
      missing_checkout: 'عدم تسجيل انصراف',
      penalty: 'جزاء',
      unpaid_leave: 'إجازة بدون أجر',
      salary_advance: 'سلفة',
      medical_insurance: 'تأمين طبي',
      advancement: 'قسط سلفة',
      new_comer: 'موظف جديد',
      overtime: 'ساعات إضافية',
      transportation: 'بدل انتقالات',
      meal: 'بدل وجبات',
      bonus: 'مكافأة',
      commission: 'عمولة',
      incentive: 'حافز',
      achievement: 'إنجاز',
      expenses: 'مصروفات',
      variable: 'راتب متغير',
      adjustment: 'تسوية',
      settlement: 'تسوية',
      other: 'أخرى',
    },

    paymentStatusPaid: 'تم صرف الراتب',
    paymentStatusUnpaid: 'لم يتم صرف الراتب بعد',
  },
  en: {
    selectMonth: 'Select Month',
    selectYear: 'Select Year',
    allMonths: 'All Months',
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',
    // Page Header
    pageTitle: 'Salary & Benefits',
    pageSubtitle: 'Comprehensive salary breakdown with Egyptian tax system calculations',
    // Loading States
    loadingSalary: 'Loading salary information...',
    creatingPayroll: 'Creating payroll...',
    // Error Messages
    errorTitle: 'Error',
    missingDataTitle: "Your salary details aren't set up yet",
    missingDataError: "There's no net, gross, or insurance salary on your account, so your payslip can't be calculated.",
    missingDataHint: 'Contact your direct manager or HR to add your salary details.',
    missingNet: 'Net salary',
    missingGross: 'Gross salary',
    missingInsurance: 'Insurance salary',
    notSet: 'Not set',
    refresh: 'Refresh',
    noSalaryData: 'No salary data available right now',
    // Statistics Cards
    grossSalary: 'Gross Salary',
    totalEarnings: 'Total earnings before deductions',
    incomeTax: 'Income Tax',
    monthlyTaxDeduction: 'Monthly tax deduction',
    socialInsurance: 'Social Insurance',
    employeeContribution: 'Employee contribution',
    netSalary: 'Net Salary',
    takeHomePay: 'Take-home pay',
    // Deductions Breakdown
    deductionsBreakdown: 'Deductions Breakdown',
    incomeTaxDesc: 'Progressive income tax based on Egyptian tax brackets',
    socialInsuranceEmployee: 'Social Insurance (Employee)',
    socialInsuranceDesc: 'Pension, disability, death, and unemployment coverage',
    martyrsFund: 'Martyrs Fund',
    martyrsFundDesc: "Mandatory contribution for martyrs' families support",
    socialInsuranceEmployer: 'Social Insurance (Employer)',
    employerContributionDesc: 'Employer contribution (not deducted from salary)',
    penalties: 'Penalties',
    sickLeave: 'Sick Leave',
    absentDays: 'Absent Days',
    // Salary Composition
    salaryComposition: 'Salary Composition',
    basicSalary: 'Basic Salary',
    allowances: 'Allowances',
    ofGrossSalary: 'of gross salary',
    // Salary Summary
    salarySummary: 'Salary Summary',
    monthlyGrossSalary: 'Monthly Gross Salary (EGP)',
    totalDeductions: 'Total Deductions (EGP)',
    netTakeHomePay: 'Net Take-Home Pay (EGP)',
    egp: 'EGP',

    allowancesBreakdown: 'Allowances Breakdown',
    transportationAllowance: 'Transportation Allowance',
    transportationAllowanceDesc: 'Monthly transportation allowance',
    variableSalaryAllowance: 'Variable Salary',
    variableSalaryDesc: 'Variable component of salary',
    overtimeAllowance: 'Overtime',
    overtimeAllowanceDesc: 'Overtime compensation',
    bonusAllowance: 'Bonus',
    bonusAllowanceDesc: 'Performance bonuses and incentives',
    expensesAllowance: 'Expenses',
    expensesAllowanceDesc: 'Reimbursed expenses',
    achievementAllowance: 'Achievement',
    achievementAllowanceDesc: 'Achievement bonus',


    printPayslip: 'Print Payslip',
    payslipFor: 'Payslip For',
    employeeInfo: 'Employee Information',
    employeeCode: 'Employee Code',
    payrollPeriod: 'Payroll Period',
    to: 'to',

    allowanceInstances: 'Allowance Instances',
    deductionInstances: 'Deduction Instances',
    type: 'Type',
    description: 'Description',
    amount: 'Amount',
    days: 'Days',
    hours: 'Hours',
    total: 'Total',
    noAllowances: 'No allowances',
    noDeductionsRow: 'No deductions',

    instanceTypes: {
      absence: 'Absence',
      late: 'Late Arrival',
      late_arrival: 'Late Arrival',
      undertime: 'Undertime',
      missing_checkout: 'Missing Check-out',
      penalty: 'Penalty',
      unpaid_leave: 'Unpaid Leave',
      salary_advance: 'Salary Advance',
      medical_insurance: 'Medical Insurance',
      advancement: 'Advancement Installment',
      new_comer: 'New Comer',
      overtime: 'Overtime',
      transportation: 'Transportation',
      meal: 'Meal',
      bonus: 'Bonus',
      commission: 'Commission',
      incentive: 'Incentive',
      achievement: 'Achievement',
      expenses: 'Expenses',
      variable: 'Variable Salary',
      adjustment: 'Adjustment',
      settlement: 'Settlement',
      other: 'Other',
    },

    paymentStatusPaid: 'Salary Paid',
    paymentStatusUnpaid: 'Salary Not Paid Yet',
  }
};


// Allowance / deduction rows store the raw backend type ("absence",
// "late_arrival", …). Admin-created custom types aren't in the map and
// render as stored.
export const getInstanceTypeLabel = (type, t) => {
  if (!type) return '-';
  return t.instanceTypes?.[String(type).toLowerCase()] || type;
};

export const getMonthName = (monthNumber, t) => {
    const monthNames = {
      1: t.january, 2: t.february, 3: t.march, 4: t.april,
      5: t.may, 6: t.june, 7: t.july, 8: t.august,
      9: t.september, 10: t.october, 11: t.november, 12: t.december
    };
    return monthNames[monthNumber] || monthNumber;
  };